import { instance } from "api/apiBase";
import { Application } from "types/application";
import { User } from "views/settings-users/types";

export const applicationApi = {
  getAssignees: async (): Promise<User[]> => {
    const { data } = await instance.get<User[]>(
      "/portal/v1/applications/assignees"
    );
    return data;
  },

  assignApplication: async ({
    application_id,
    assignee_ids
  }: {
    application_id: number;
    assignee_ids: number[];
  }): Promise<Application> => {
    const { data } = await instance.post<Application>(
      "/portal/v1/applications/bulk_assign",
      {
        application_ids: [application_id],
        assignee_ids
      }
    );
    return data;
  },

  bulkAssignApplications: async ({
    application_ids,
    assignee_ids
  }: {
    application_ids: number[];
    assignee_ids: number[];
  }): Promise<Application> => {
    const { data } = await instance.post<Application>(
      "/portal/v1/applications/bulk_assign",
      {
        application_ids,
        assignee_ids
      }
    );
    return data;
  }
};
